<template>
  <VisaForm country="usa" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid biometric />
      <EmergencyContactFields v-model="form.emergencyContact" />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFieldsUsa v-model="applicant.extraNationality" />
          <AddressFields v-model="applicant.address" />
          <CityOfBirth v-model="applicant.cityOfBirth" />
          <FamilyDetailsFields v-model="applicant.family" has-marital-status />
          <OccupationFields v-model="applicant.occupation" has-address has-past-job />
          <PastRejection v-model="applicant.pastRejection" />
          <CrimeFields v-model="applicant.crime" />
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>